import { Bookmarkplans } from "components/features/library/Bookmark/Bookmark";
import {
  fetchBookmarkPlansAsync,
  fetchBookmarkPlansIdAsync
} from "components/features/library/Bookmark/Bookmark.slice";
import { useTranslate } from "hooks/useTranslate";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DISPLAY_TYPE, PAGE_SIZE, allPlansType } from "utils/CommonConstants";
import ConfigTabsData from "../ConfigTabsData";
import { fetchBookmarkedInncodeAsync } from "../Dashboard.slice";
import { TAB } from "./TAB";

const BookmarkPlansProperties = (props: any) => {
  const { tab } = props;
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  let innCode = useAppSelector((state: any) => state.app.innCode);
  const bookmarkPlansList: any = useAppSelector((state: any) => state.bookmarkedPlans.bookmarkedPlansList);
  const bookmarkedPlanIdList: any = useAppSelector((state: any) => state.bookmarkedPlans.list);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const check = isCorp ? "CORP" : innCode;
  const innCodeBookmark: Bookmarkplans = bookmarkedPlanIdList?.find((item: any) => item.innCode === check);
  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  const selectedFunctionalAreas = useAppSelector((state: any) => state.app.selectedFunctionalAreas);
  const bookMarkInncodes = useAppSelector((state: any) => state.Dashboard.bookMarkInncodes);
  const filterIds = useAppSelector((state: any) => state.app.filterIds);
  const [searchParams] = useSearchParams();

  /*need to check inncode dependancy */
  const selectedInncode = searchParams.get("inncode");
  innCode = selectedInncode ?? innCode;
  const plansTabSelected = tab === TAB.plans;

  const getProps = () => {
    return {
      filter: {
        innCode: isCorp ? "CORP" : innCode,
        ids: bookmarkPlanIds,
        functionalAreaIds: selectedFunctionalAreas,
        filterIds
      },
      pagination: {
        page: 1,
        size: PAGE_SIZE
      },

      planType: [allPlansType]
    };
  };
  const fetchBookMarkedPlans = async () => {
    await dispatch(fetchBookmarkPlansIdAsync());
    if (bookmarkPlanIds.length > 0) await dispatch(fetchBookmarkPlansAsync(getProps()));
  };
  useEffect(() => {
    if (tab === TAB.properties) {
      dispatch(fetchBookmarkedInncodeAsync({}));
    } else {
      fetchBookMarkedPlans();
    }
  }, [tab]);

  const getUrl = (element: any) => {
    return plansTabSelected ? `/planDetails/${element.id}` : `/property/${element.innCode}?parentTab=Property+Plans`;
  };

  return (
    <>
      <ConfigTabsData
        dataList={plansTabSelected ? bookmarkPlansList?.slice(0, 5) : bookMarkInncodes?.slice(0, 5)}
        tab={tab}
        dateDetails={plansTabSelected}
        showInncode={!plansTabSelected}
        showPlanDate={plansTabSelected}
        type={DISPLAY_TYPE.bookmarkedPropertiesPlans}
        shouldNavigate={true}
        noDataMessage={
          plansTabSelected ? translate("dashboard.noBookMarkedPlans") : translate("dashboard.noBookMarkedProperties")
        }
        getUrl={getUrl}
        navigateState={{ isMyLists: true, defaultTab: 1 }}
      />
    </>
  );
};
export default BookmarkPlansProperties;
